export const INTERVALS = [
  {
    id: '0:45',
    hours: 0,
    minutes: 45,
  },
  {
    id: '1:00',
    hours: 1,
    minutes: 0,
  },
  {
    id: '1:30',
    hours: 1,
    minutes: 30,
  },
  {
    id: '2:00',
    hours: 2,
    minutes: 0,
  },
  {
    id: '2:30',
    hours: 2,
    minutes: 30,
  },
  {
    id: '3:00',
    hours: 3,
    minutes: 0,
  },
  {
    id: '3:30',
    hours: 3,
    minutes: 30,
  },
  {
    id: '4:00',
    hours: 4,
    minutes: 0,
  },
  {
    id: '4:30',
    hours: 4,
    minutes: 30,
  },
  {
    id: '4:45',
    hours: 4,
    minutes: 45,
  },
];
